import React, { useEffect, useState } from "react";
import FaqItem from "./FaqItem";
import { getToken } from '../utils/cookieUtils';
function Faq() {
  const [faqs, setFaqs] = useState([])

  const updateFaqs = async () => {
    try {
      let data = await fetch(`${process.env.REACT_APP_BASE_URL}general/faqs`, {
        headers: {
          "Authorization": "Bearer " + getToken(),
        }
      });
      let parsedData = await data.json();
      setFaqs(parsedData.data || []);
    } catch (error) {
      ////console.error('Error fetching FAQs:', error);
      setFaqs([]);
    }
  }
  useEffect(() => {
    updateFaqs();
    // eslint-disable-next-line
  }, [])
  return (
    <>
      <div className="container py-4 my-4" id="faq">
        <h4 className="text-center my-2 py-2">FAQ's</h4>
        <div className="list-group my-2" id="faq-list">
          {
            faqs && faqs.length > 0 ? faqs.map((element, index) => {
              return <FaqItem key={index} index={index} element={element} />
            }) : <div className="text-center py-4">No FAQs available</div>
          }
        </div>
      </div>
    </>
  );
}

export default Faq;
